import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import arrow_back from '../assets/arrow_back.svg';
import logoDpr from '../assets/dpr_lab_logoA.png';

import salir from '../assets/logout.png';
import check from '../assets/check.svg';
import { mtDeletePerson } from "../api/mtDeletePerson";
import './style.css'

// import HorizontalNonLinearStepper from '../step/step';


function Header({ imgBack, imgBackRig, rutaBack, title, name }) {
    const navigate = useNavigate();

    const onBackPage = async () => {
        navigate(rutaBack);
    }

    // Modal
    const [show, setShow] = useState(false);
    const handleback = () => setShow(false);
    const handleClose = () => setShow(window.location.href="http://google.com");
    const handleShow = () => setShow(true);
    
    const btnMtDeletePerson = async () => {

       // const objCons = {
       //     id: localStorage.getItem('idPerson')
       // }
       // const response = await mtDeletePerson(objCons);

      //  if (response.status == 200) {
            localStorage.clear();
            window.location.href='https://mydpr.icu/'
      //  }
    }

    return (
        <>
            <div className='backTitleDem_P2'>
                <div className='steep'>
                    <img className='logoHeader' src={logoDpr} />
                </div>
                <div className='imgLeft'>
                    {!imgBack ? (
                        <></>
                    ) : (
                        <>
                            <img src={arrow_back} align="left" onClick={onBackPage} />
                        </>
                    )}
                        
                </div>
                <div className='imgRight'>
                    {!imgBackRig ? (
                        <></>
                    ) : (
                        <>
                            <img src={salir} onClick={handleShow} />

                            <Modal 
                                size="sm" 
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                                backdrop="static" 
                                show={show} 
                                onHide={handleClose}>
                                    <Modal.Body className="modal-red"> 
                                    <div>
                                        <p className='title-body'>
                                            Atención
                                        </p>
                                        <p className='message-body'>
                                            Está por salir de la sesión.
                                        </p>
                                    </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <br />
                                        <button className='button-back' onClick={handleback}>
                                            <span className='text-back'>
                                                Regresar
                                            </span> 
                                        </button>
                                        <button className='button-confirm' onClick={btnMtDeletePerson}>
                                            <span className='text-confirm'>
                                                Confirmar
                                            </span> 
                                        </button>
                                        <br />
                                    </Modal.Footer>
                            </Modal>
                        </>
                    )}
                </div>
            </div>
            <div className='life'>
                <div id="life-bar">
                    {/* Identificación personal */}
                    { name === 'steepOne'  &&  (<div> <div className="filled25"></div> <div className="empty25"></div> </div>) }
                    {/* { name === 'steepTwo' && (<div> <div className="filled50"></div> <div className="empty50"></div> </div>) } */}
                    { name === 'steepThree' && (<div> <div className="filled75"></div> <div className="empty75"></div> </div>) }
                    { name === 'steepFour' && (<div> <div className="filled100"></div> <div className="empty100"></div> </div>) }
                    {/* Licencia de conducir */}
                    { name === 'HomeLicConducir'  &&  (<div> <div className="filled10"></div> <div className="empty10"></div> </div>) }
                    { name === 'TipoLicencia'  &&  (<div> <div className="filled25"></div> <div className="empty25"></div> </div>) }
                    { name === 'NumeroLic'  &&  (<div> <div className="filled50"></div> <div className="empty50"></div> </div>)}
                    { name === 'LicDate'  &&  (<div> <div className="filled75"></div> <div className="empty75"></div> </div>)}
                    {/* Conocimiento vial */}
                    { name === 'HomeExpProfesional'  &&  (<div> <div className="filled10"></div> <div className="empty10"></div> </div>) }
                    {/* { name === 'QuestionExpProfesional'  &&  (<div> <div className="filled50"></div> <div className="empty50"></div> </div>) } */}
                    { name === 'ValidarData'  &&  (<div> <div className="filled100"></div> <div className="empty100"></div> </div>) }
                
                    { name === 'HomeConicimientoVial'  &&  (<div> <div className="filled10"></div> <div className="empty10"></div> </div>) }
                    {/* { name === 'QuestionConocimientoVial'  &&  (<div> <div className="filled50"></div> <div className="empty50"></div> </div>) } */}
                        

                    
                </div>
            </div>

            {/* <HorizontalNonLinearStepper/> */}
            <div className='backIdenPersonal_P2'>
                <p className='txtIdenPerso_P2'>{title}</p>
            </div>
        </>
    )
}

export default Header
